import { useEffect, useState } from "react";
import { post } from "../networking/RequestService";

const useGetTagsForProfile = (profileId) => {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTags = async () => {
        if (!profileId) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "getTagsForProfile",
                profileId,
            });

            setTags(res.data.tags || []);
        } catch (err) {
            setError(err);
            setTags([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTags();
    }, [profileId]);

    return { tags, loading, error, refetch: fetchTags };
};

export default useGetTagsForProfile;
